<template>
  <v-dialog v-model="show" persistent max-width="300px">
    <v-card>
      <v-toolbar color="primaryLight" dark dense>
        <v-toolbar-title>Track entre fechas</v-toolbar-title>
      </v-toolbar>

      <v-card-text>
        <v-form v-model="isValid">
          <v-container>
            <v-row>
              <v-col>
                <vx-date-text-edit v-model="fechaInit" label="Fecha inicio" icon="esri-icon-calendar" :max="maxFechaInit" not-future required />
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <vx-date-text-edit v-model="fechaFin" label="Fecha fin" icon="esri-icon-calendar" :min="minFechaInit" not-future required />
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn text color="red" @click="cancelar">Cancelar</v-btn>
        <v-btn text color="green" :disabled="!isValid" @click="aceptar">Aceptar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import DateService, { FMT } from '@/helpers/DateService'
export default {
  props: {
    show: Boolean
  },

  data: () => ({
    isValid: false,

    fechaInit: null,
    fechaFin: null
  }),

  watch: {
    show () {
      this.fechaInit = null
      this.fechaFin = null
    }
  },

  computed: {
    minFechaInit () {
      return this.fechaFin ? this.fechaFin : undefined
    },

    maxFechaInit () {
      return this.fechaFin ? this.fechaFin : this.$date.now().format(FMT.date)
    }
  },

  methods: {
    cancelar () {
      this.$emit('cancelar')
    },
    aceptar () {
      this.fechaInit = this.$date.parseDate(this.fechaInit).toISOString()
      this.fechaFin = this.$date.parseDate(this.fechaFin).toISOString() // + ' 23:59:59'
      this.$emit('aceptar', this.fechaInit, this.fechaFin)
    }
  }
}
</script>

<style scoped>
</style>
